module.exports = __webpack_public_path__ + "img/pf.a7652353.png";